import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, Router, RouterStateSnapshot } from '@angular/router';
import { map, of } from 'rxjs';
import { OrderService } from '@services/order.service';
import { ToastService } from '@services/toast.service';
import { TOAST_TYPE } from '../constants/app.constant';
import { OrderDetail } from '@models/order.model';
import { BaseResponseModel } from '@models/app.model';
import { TranslateService } from '@ngx-translate/core';

export const orderDetailResolver: ResolveFn<BaseResponseModel<OrderDetail> | null> = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
) => {
    const orderService = inject(OrderService);
    const toastService = inject(ToastService);
    const translateService = inject(TranslateService);
    const router = inject(Router);
    const code = route.queryParamMap.get('code');

    if (!code) {
        router.navigate(['report', 'orders']);
        return of(null);
    }

    return orderService.getDetailOrderByCode(code).pipe(
        map((v) => {
            if (!v) {
                toastService.add({
                    severity: TOAST_TYPE.ERROR,
                    summary: translateService.instant('common.tabs.error'),
                    detail: translateService.instant('pages.booking.toast.messages.orderFailed'),
                });
                router.navigate(['report', 'orders']);
            }
            return v;
        })
    );
};
